import * as React from 'react';
import Tooltip from '../tooltip/Tooltip';
import { MAX_PROGRESS_LENGTH } from './constants';
import './ProgressBar.scss';

export interface IProgressBarProps {
  id: string | number;
  label: string;
  underLabel?: string;
  score: number;
  maxScore: number;
  widthPercentage?: number;
  className?: string;
}

export const ProgressBar: React.FC<IProgressBarProps> = ({
  id,
  label,
  score,
  maxScore,
  widthPercentage,
  className = '',
  underLabel,
}) => {
  const perc = Math.round((100 * score) / maxScore);
  const begWidth = widthPercentage ?? 100 / MAX_PROGRESS_LENGTH;
  const margin = begWidth / 3;

  const style: React.CSSProperties = {
    // Min height of 5% if score is above 0
    height: perc === 0 ? `1%` : `${Math.max(perc, 5)}%`,
    width: `calc((${begWidth}%) - ${margin}%)`,
    marginRight: `${margin}%`,
  };
  const labelSize = Math.min(begWidth * 4, 200);
  const underLabelStyle: React.CSSProperties = {
    fontSize: `${labelSize}%`,
  };
  return (
    <div className="progress-bar-container" style={style} data-testid="progress-bar">
      <div className={`progress-bar ${className}`}>
        <Tooltip id={`progress-bar-${id}`} title={label} className="dark noshadow" position="top">
          <div></div>
        </Tooltip>
      </div>
      {underLabel && (
        <div className="progress-bar-underlabel" style={underLabelStyle}>
          {underLabel}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
